import { useTranslation } from 'react-i18next';

import { Field, Input } from '~/components/Form';

type Props = {
  entryNumber: null | string;
};

export const FormEntryNumber = ({ entryNumber }: Props) => {
  const { t } = useTranslation(['invoices']);

  return (
    <Field.Root disabled name="entryNumber">
      <Field.Label>{t('invoices:fields.entryNumber.label')}</Field.Label>
      <Input defaultValue={entryNumber ?? ''} disabled />
    </Field.Root>
  );
};
